/**
 * reviews.js — the 12 public 5★ Google Play reviews of Keep Me Out shown on the site (spec §9).
 *
 * `text` is verbatim, character for character. The only edits are trims marked with "…" (U+2026),
 * which keep word order; `trimmed` records them. Spelling is the reviewer's own — never correct it.
 * Every review here is a KEEP ME OUT review: never present one as a Bring Me Back review.
 */
import { MK_FLAGS } from './flags';

const list = [
  {
    key: 'lucy',
    playReviewId: 'e7587f85-6119-4ff9-b544-dec2438072fd',
    factId: 'kmo-review-lucy',
    displayName: 'Lucy M.',
    stars: 5,
    month: 'Jul 2026',
    text: 'I love that it keeps me out of my phone. Helps with focus.',
    trimmed: false,
  },
  {
    key: 'alaa',
    playReviewId: 'd16dd5c5-8edd-469a-8283-1a10bad1510c',
    factId: 'kmo-review-alaa',
    displayName: 'Alaa A.',
    stars: 5,
    month: 'Apr 2026',
    text: "goood. they say don't depend on will power to be disciplined, and change your environment to achieve so. this helps much with that",
    trimmed: false,
  },
  {
    key: 'reem',
    playReviewId: '03339b3d-443b-4c6e-b0ad-c41448485ea7',
    factId: 'kmo-review-reem',
    displayName: 'Reem',
    stars: 5,
    month: 'Jun 2026',
    text: "… When I want to concentrate, I open it; there's no going back or canceling it until the time is up, so I can really focus. …",
    trimmed: true,
  },
  {
    key: 'ghislaine',
    playReviewId: '48a2171d-e7a1-4bca-826f-4816888d8305',
    factId: 'kmo-review-ghislaine',
    displayName: 'Ghislaine',
    stars: 5,
    month: 'Jun 2026',
    text: "genuinely awesome. I now go to bed at 10.30 and it kicks me out in the evenings too when I'm supposed to be studying.",
    trimmed: false,
  },
  {
    key: 'anshu',
    playReviewId: 'bce81d09-1c77-4613-9b1a-a53e4e647bc8',
    factId: 'kmo-review-anshu',
    displayName: 'Anshu R.',
    stars: 5,
    month: 'Jul 2026',
    text: 'the new feature is amazing to allow app on locked screen',
    trimmed: false,
  },
  {
    key: 'joe',
    playReviewId: 'b14206db-97ad-401e-bc08-a017b087048c',
    factId: 'kmo-review-joe',
    displayName: 'Joe S.',
    stars: 5,
    month: 'Jul 2026',
    text: "Previous issues have been resolved and I'm back to enjoying the freedom that comes with locking myself out of my phone! :)",
    trimmed: false,
  },
  {
    key: 'stella',
    playReviewId: '53b1b173-b390-4516-9b6c-becf38868a4c',
    factId: 'kmo-review-stella',
    displayName: 'Stella',
    stars: 5,
    month: 'Oct 2025',
    text: "Although it's really annoying, it is perfect and I'm getting much better sleep since I'm not on my phone as much.",
    trimmed: false,
  },
  {
    key: 'dylan',
    playReviewId: '60218460-6d2c-4ff9-a11b-36cdfe4dfad9',
    factId: 'kmo-review-dylan',
    displayName: 'Dylan H.',
    stars: 5,
    month: 'Oct 2023',
    text: "This is a great app for revision! I am guilty of picking up my phone 10 minites into revision and then being lost in applications and suddenly an hours past and I haven't done any revision. … It has really helped me to get a lot of good revision done for my GCSE's I would highly recommend getting the app",
    trimmed: true,
  },
  {
    key: 'abshir',
    playReviewId: '5234530f-4461-4746-8160-45e5fd666331',
    factId: 'kmo-review-abshir',
    displayName: 'Abshir M.',
    stars: 5,
    month: 'Oct 2025',
    text: "I don't know what to say really, I wish I knew this app years ago when I suffered from endless scroll on social media. thanks thousands of times for this app",
    trimmed: false,
  },
  {
    key: 'amrit',
    playReviewId: '4827cd0f-6f47-4b45-91fe-a3e38936e176',
    factId: 'kmo-review-amrit',
    displayName: 'Amrit K.',
    stars: 5,
    month: 'Sep 2026',
    text: 'user for long time. i have tried all the apps but none of them do what this apps does. literally hands down the best app.',
    trimmed: false,
  },
  {
    key: 'shakya',
    playReviewId: '81b0949d-a802-41c4-abac-7ee3c2f99002',
    factId: 'kmo-review-shakya',
    displayName: 'Shakya R.',
    stars: 5,
    month: 'Jul 2025',
    text: "works great. Surprisingly high quality functional app that does what it's supposed to very well. props to the developers.",
    trimmed: false,
  },
  {
    key: 'ben',
    playReviewId: 'f0da7fb4-9f12-44a6-92c7-1c3ff800e3b8',
    factId: 'kmo-review-ben',
    displayName: 'Ben H.',
    stars: 5,
    month: 'Aug 2022',
    text: 'Amazing, just like locking your phone in a drawer … Really easy to use, and it gives you the ability to create schedules if you want to be extra stricked. Has a widget attached. Just amazing, everything I need',
    trimmed: true,
  },
];

export const REVIEW_LIST = list;

/** Reviews by key, e.g. REVIEWS.lucy */
export const REVIEWS = list.reduce((acc, r) => {
  acc[r.key] = r;
  return acc;
}, {});

/** The name shown next to a review, honouring the G2 gate. */
export function displayName(review, approved = MK_FLAGS.REVIEWER_NAMES_APPROVED) {
  return approved ? review.displayName : 'Google Play user';
}
